import Routes from "security-app/routing/Routes";
import { CONFIGURATION_NAV_TITLE } from "common/Constants";
export const PAGE_NAV_TITLE = "Investigations";
const investigationsPageNavigation = {
  description: PAGE_NAV_TITLE,
  children: [
    {
      description: "Open",
      titleKey: "enterprise_navigation:investigations.open",
      path: Routes.INVESTIGATIONS.LIST,
      exactPathMatch: true
    },
    {
      description: "Archived",
      titleKey: "enterprise_navigation:investigations.archived",
      path: Routes.INVESTIGATIONS.ARCHIVED
    },
    {
      description: CONFIGURATION_NAV_TITLE,
      titleKey: "enterprise_navigation:investigations.configuration",
      path: Routes.INVESTIGATIONS.CONFIGURATION,
      permissions: "investigations:edit"
    }
  ]
};
export default investigationsPageNavigation;
